module.exports = __webpack_public_path__ + "static/img/project-item.11a6cc9b.png";